module.exports = __webpack_public_path__ + "static/media/nav2.586ac4d3.png";